import { Colors } from '../../theme'

const sharedDropDownStyles = {
  color: Colors.Palette.primaryTextColor
}

export default {
  baseDropdown: {
    ...sharedDropDownStyles,
    width: 240
  },
  hcsaDropdown: {
    ...sharedDropDownStyles,
    width: 270
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/dropdown.js